export const SOUND_STORAGE_STRATEGY_TOKEN = Symbol('SOUND_STORAGE_STRATEGY_TOKEN');

export interface SoundStorageState {
  backgroundMusic: boolean;
  soundFX: boolean;
}

export interface SoundStorageStrategy {
  save(state: SoundStorageState): void;
  getSaved(): SoundStorageState | null;
}
